import React, { useEffect, useState, Fragment } from 'react';
import { toast } from 'react-toastify';
import api from '../../config/axios';
import Breadcrumb from '../common/breadcrumb';
import { date } from '../../utils/date';
import { Star, Phone, MessageCircle } from 'react-feather';

const MyLeads = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchLeads();
    }, []);

    const fetchLeads = async () => {
        try {
            const { data } = await api.get('/lead/mine');
            setLeads(data.data || []);
        } catch (err) {
            toast.error('Error al cargar tus leads');
        } finally {
            setLoading(false);
        }
    };

    const handleWhatsApp = (lead) => {
        const phoneParsed = lead.phone.replace('0', '58');
        const message = `Hola ${lead.name}, soy tu repartidor de Aguaman. Le escribo para recordarle que tiene mi número guardado — cuando le quede sin agua, escríbame y en 30 minutos tiene el botellón en su casa.`;
        window.open(`https://wa.me/${phoneParsed}?text=${encodeURIComponent(message)}`);
    };

    return (
        <Fragment>
            <Breadcrumb title="Mis leads" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    </div>
                                ) : leads.length === 0 ? (
                                    <div className="text-center py-5">
                                        <p style={{ fontSize: 18, color: '#777' }}>
                                            No has captado leads aún
                                        </p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Nombre</th>
                                                    <th>Teléfono</th>
                                                    <th>Observación</th>
                                                    <th>Fecha de captura</th>
                                                    <th>Estado</th>
                                                    <th>Acción</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leads.map((lead) => (
                                                    <tr key={lead.id}>
                                                        <td>{lead.name}</td>
                                                        <td>{lead.phone}</td>
                                                        <td>{lead.observation || '-'}</td>
                                                        <td>{date(lead.createdAt)}</td>
                                                        <td>
                                                            {lead.status === 'creado' ? (
                                                                <span className="badge badge-warning">
                                                                    Pendiente
                                                                </span>
                                                            ) : (
                                                                <span className="badge badge-success">
                                                                    Convertido ✅
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>
                                                            {lead.status === 'creado' && (
                                                                <button
                                                                    className="btn btn-sm btn-success"
                                                                    onClick={() => handleWhatsApp(lead)}
                                                                >
                                                                    <MessageCircle size={14} /> Seguimiento
                                                                </button>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default MyLeads;
